export const PERSIST_BAN_LIST = [
  'downloader',
  'player',
  'user',
  'question-response',
  'question-path',
  'content-modal',
];
